import { getErrorMsgAndCode, validateInput } from "./FrontendHelpers";
import api from "./axios";

import { t } from "i18next";

const checkInput = (ID, Name, Price, SellingPrice) => {
  return validateInput([
    {
      Name: "ID",
      Value: ID,
      Type: "itemID",
      MaxLengthType: "id",
      MinLength: 1,
    },
    {
      Name: "Name",
      Value: Name,
      Type: "string",
      MinLength: 1,
      MaxLengthType: "name",
    },
    {
      Name: "Price",
      Value: Price,
      Type: "float",
      MaxLengthType: "price",
      MinLength: 1,
    },
    {
      Name: "Selling Price",
      Value: SellingPrice,
      Type: "float",
      MaxLengthType: "price",
      MinLength: 0,
      AllowZero: true,
    },
  ]);
};

export async function GetItems() {
  try {
    const response = await api.get("/getItems");
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function TransferStock(
  SourceWarehouseID,
  DestinationWarehouseID,
  items
) {
  try {
    const data = {
      SourceWarehouseID: SourceWarehouseID,
      DestinationWarehouseID: DestinationWarehouseID,
      items: items,
    };
    const response = await api.post("/transferStock", data);
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function SubmitStockCount(WarehouseID, counts) {
  try {
    const data = { WarehouseID: WarehouseID, counts: counts };
    const response = await api.post("/submitStockCount", data);
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetLowStockItems() {
  try {
    const response = await api.get("/getLowStockItems");
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function GetItemsPerWarehouse() {
  try {
    const response = await api.get("/getItemsPerWarehouse");
    const data = response.data;
    const map = new Map();
    data.forEach((element) => {
      map.set(element.Name, element.Items);
    });

    return [map, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function GetItemsPerClient() {
  try {
    const response = await api.get("/getItemsPerClient");
    const data = response.data;
    const map = new Map();
    data.forEach((element) => {
      map.set(element.Name, element.Items);
    });

    return [map, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

//pass -1 to id if you want to check all warehouses
export async function GetItemAmountMinMax(id) {
  try {
    const data = { ID: id };
    const response = await api.post("/getItemAmountMinMax", data);
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetItemPriceMinMax() {
  try {
    const response = await api.post("/getItemPriceMinMax");
    const info = response.data;
    console.log("Test price datya", info);
    return [info, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function GetItemSellingPriceMinMax() {
  try {
    const response = await api.post("/getItemSellingPriceMinMax");
    const info = response.data;
    console.log("Test price datya", info);
    return [info, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetItemsInWarehouse(id) {
  const data = { ID: id };
  try {
    const response = await api.post("/getItemsForWarehouse", data);
    const info = response.data;
    return [info, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
export async function GetItemsInNote(id) {
  const data = { ID: id };
  try {
    const response = await api.post("/getItemsInNote", data);
    const info = response.data;
    console.log("Got items in note", info);
    return [info, null];
  } catch (error) {
    console.log("Got items in note FAILED", error);

    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetItemData(argument, bywhat = "ItemID") {
  try {
    const data = { Argument: argument, byWhat: bywhat };
    const response = await api.post("/getItemInfo", data);
    const info = response.data;
    console.log(response.data);

    return [info[0], null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetItemDataInWarehouse(ItemID, WarehouseID) {
  try {
    const data = { ItemID: ItemID, WarehouseID: WarehouseID };

    const response = await api.post("/getItemInfoInWarehouse", data);

    const result = response.data;

    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CreateItem(
  ID,
  Barcode,
  Name,
  Unit,
  Price,
  SellingPrice,
  Tags,
  Clients,
  MinStock
) {
  try {
    const data = {
      ID: ID,
      Barcode: Barcode,
      Name: Name,
      Tags: Tags,
      Clients: Clients,
      Unit: Unit,
      Price: Price,
      SellingPrice: SellingPrice,
      MinStock: MinStock,
    };

    const validationError = checkInput(ID, Name, Price, SellingPrice);
    if (validationError.errCode !== 0) return [null, validationError];

    const response = await api.post("/createItem", data);

    const result = response.data;
    return [result, null];
  } catch (error) {
    console.log("Error in item hook", error);
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function BulkCreateItems(items) {
  try {
    const response = await api.post("/bulkCreateItems", { items });
    return [response.data, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function GetNextItemID() {
  try {
    const response = await api.get("/getNextItemID");
    const data = response.data;
    return [data.nextID, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function EditItem(
  ID,
  NewID,
  Barcode,
  Name,
  Unit,
  Price,
  SellingPrice,
  Tags,
  Clients,
  MinStock
) {
  try {
    const data = {
      ID: NewID,
      Barcode: Barcode,
      Name: Name,
      Tags: Tags,
      Clients: Clients,
      Unit: Unit,
      Price: Price,
      SellingPrice: SellingPrice,
      CurrentID: ID,
      MinStock: MinStock,
    };

    const validationError = checkInput(ID, Name, Price, SellingPrice);
    if (validationError.errCode !== 0) return [null, validationError];

    await api.post("/editItem", data);
    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function DeleteItem(id) {
  try {
    const data = { ID: id };

    await api.post("/deleteItem", data);
    return [null, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function CheckForItem(id) {
  try {
    const data = { ID: id };

    const response = await api.post("/checkForItem", data);
    const info = response.data;
    if (info[0]) {
      return [true, null];
    }
    return [false, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}

export async function AddItemsToWarehouse(WarehouseID, items, NoteType) {
  try {
    const data = { WarehouseID: WarehouseID, items: items, NoteType: NoteType };

    const validationError = validateInput([
      { Name: "Type", Type: "string", Value: NoteType, MinLength: 1 },
      {
        Name: "Items",
        Type: "string",
        Value: items,
        Message: t("validation.At least one item is required.", {
          ns: "error",
        }),
        MinLength: 1,
      },
      {
        Name: "WarehouseID",
        Type: "warehouseID",
        Value: WarehouseID,
        Message: t("validation.You must pick a warehouse.", { ns: "error" }),
      },
    ]);
    if (validationError.errCode !== 0) return [null, validationError];
    console.log("items in helpers", items);

    const response = await api.post("/addItemsToWarehouse", data);

    const result = response.data;
    return [result, null];
  } catch (error) {
    const errorObj = getErrorMsgAndCode(error);
    return [null, errorObj];
  }
}
